import { createActions } from 'redux-actions';
import { addFlashMessage, clearMessage } from '../Flash';
import api from '../../../api';
import { getErrorMessages } from '../../../shared/helpers';

export const {
  setUnreadNotifications,
  setNotifications,
  setReadNotification,
  setNotificationsThreadInterval,
  clearNotificationsThreadInterval,
} = createActions(
  {
    SET_UNREAD_NOTIFICATIONS: isNewNotifications => ({ isNewNotifications }),
    SET_NOTIFICATIONS: ({ notifications, pagination }) => ({
      notifications,
      pagination,
    }),
    SET_READ_NOTIFICATION: notification => notification,
    SET_NOTIFICATIONS_THREAD_INTERVAL: interval => ({
      interval,
    }),
  },
  'CLEAR_NOTIFICATIONS_THREAD_INTERVAL',
);

export const checkNewNotifications = () => dispatch => {
  dispatch(clearMessage());
  return api
    .checkNewNotifications()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(clearNotificationsThreadInterval());
      }
      return dispatch(setUnreadNotifications(json.notifications));
    })
    .catch(() => {
      dispatch(clearNotificationsThreadInterval());
    });
};

export const getNotifications = params => dispatch => {
  dispatch(clearMessage());
  return api
    .getNotifications({
      ...params,
      'q[s][]': 'read',
      '&q[s][]': 'created_at',
    })
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(setNotifications(json));
    })
    .catch(e => {
      const errors = getErrorMessages(
        e,
        'Was not possible to load your notification the this moment, please try again later.',
      );
      return dispatch(addFlashMessage(errors, 'error'));
    });
};

export const markAllAsRead = () => dispatch => {
  dispatch(clearMessage());
  return api
    .markAllNotificationsAsRead()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(setUnreadNotifications(json.notifications));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      return dispatch(addFlashMessage(errors, 'error'));
    });
};

export const updateNotification = notification => dispatch => {
  dispatch(clearMessage());
  return api
    .updateNotification(notification.id, notification)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(setReadNotification(json));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      return dispatch(addFlashMessage(errors, 'error'));
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/Notification/index.js